import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function FeederWrapsRow() {
   return (
      <InputRangeRow
         titleProp={"Feeder Wraps"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={1}
         maxProp={3}
         propertyNameProp={"feederWraps"}
         errorDialogueProp={"1-3 only"}
         floatProp={false}
      />
   );
}
